export default __webpack_public_path__ + "static/media/Logo.131f025a.png";